import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#525866",
      d: "M15.272 1.586h2.811l-6.142 7.02 7.226 9.552h-5.658l-4.43-5.794-5.07 5.794H1.194l6.57-7.509L.833 1.586h5.801L10.64 6.88zm-.987 14.889h1.558L5.788 3.18H4.116z"
    }, null, -1)
  ])))
}
export default { render: render }